import { Component } from '@angular/core';
import {DxBaseCellRenderComponent} from "../dx-base-cell-render.component";
import {ICellRendererParams} from 'ag-grid-community';
import {DxDateTime} from 'src/app/dx-core/utiles/dx-core-datetime-utils';

@Component({
  selector: 'dx-datetime-cell-render',
  templateUrl: './dx-datetime-cell-render.component.html',
  styleUrls: ['./dx-datetime-cell-render.component.css']
})
export class DxDatetimeCellRenderComponent extends DxBaseCellRenderComponent {

  constructor() {
    super();
  }

  protected _init(params: ICellRendererParams): void {
    super._init(params);
    // console.log(params);
    const dataType = this._columnOptions.dataType;
    let format: string;
    if (dataType.format) {
      format = dataType.format;
    } else if (dataType.isDate) {
      format = DxDateTime.dateTimeFormats['date'];
    } else if (dataType.isDateTime) {
      format = DxDateTime.dateTimeFormats['datetime'];
    } else format = DxDateTime.dateTimeFormats['time'];
    this.value = DxDateTime.dateTimeToStr(this._params.value, format);
  }

  // public transform(value: any): string {
  //   return value.toString();
  // }

}
